export const FILTER_SCROLL_TOP_ID = 'filter-top';
export const intersectionObserverOptions = {
    rootMargin: '0px 0px -15px 0px',
};
export const intersectionTopObserverOptions = {
    rootMargin: '15px 0px 10px 0px',
};
export const intersectionEndObserverOptions = {
    rootMargin: '0px',
};
